import React from 'react';
import { Sidebar } from './Sidebar';
import { BottomNav } from './BottomNav';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen bg-background text-text-primary font-sans selection:bg-primary/30 selection:text-white" data-id="element-89">
      <Sidebar data-id="element-90" />

      <main className="md:pl-64 min-h-screen pb-20 md:pb-0 transition-all duration-300" data-id="element-91">
        <div className="max-w-7xl mx-auto p-4 md:p-8" data-id="element-92">{children}</div>
      </main>

      <BottomNav data-id="element-93" />
    </div>;
}